import React, { useState, useEffect, useContext, useRef } from 'react'
import { useNavigate, useParams, Navigate } from 'react-router-dom'
import './index.css'
import { AuthContext } from '../../App.js'
import Header from '../Header'
import ModalStornAlert from '../ModalStornAlert'
import ModalLogoutAlert from '../ModalLogoutAlert'
import Loading from '../LoadingComponent'
import Confirmation from '../ConfirmationComponent'
import {Button, ButtonGroup, Table, TableHead, TableBody, TableRow, TableCell, TextField, InputAdornment, Checkbox, makeStyles, useMediaQuery} from '@material-ui/core'
import axios from 'axios'
import md5 from 'blueimp-md5'
import { getHostName, getHostNameTPS } from '../../base.js'
import COLORS from '../../colors.js'
import CircleCheckedFilled from '@material-ui/icons/CheckCircle'
import CircleUnchecked from '@material-ui/icons/RadioButtonUnchecked'
import { isMobile } from 'react-device-detect'
import { useSwipeable } from 'react-swipeable'

const useStyles = makeStyles((theme) => ({
	btnGroup: {
		display: 'flex',
		justifyContent: 'center',
		padding: '1rem',	
	},
	btnOn:{
		background: COLORS.blue,
		width: '10rem',
		color: '#fff',
		fontSize:"0.875rem",
	    textTransform: 'none',
		'&:hover': {
			background: COLORS.blue,
		},
	},
	btnOff:{
		color: COLORS.blue,
		width: '10rem',
		background: '#fff',
		fontSize:"0.875rem",
		textTransform: 'none',
		'&:hover': {
			background: COLORS.gray,
		},
	},
	table: {
		width:'100%',       
  	},
	tableRow: {
		'&:hover': {
			  zIndex: '1000',
			  backgroundColor: COLORS.gray,
		}
  	},
  	checkbox: {
		padding:'1rem',
		margin: '0rem',
  	},
  	nameHead: {
		paddingTop:'0.6rem',
		paddingBottom:'0.6rem',
		padingRight: 0,
		paddingLeft:0,
		margin:0,
		color:'#5F6767',
		fontWeight: '500',
  	},
  	priceHead: {
		padding:0,
		margin:0,
		color:'#5F6767',
		fontWeight: '500',
  	},
  	quantityHead:{
		padding:0,
		margin:0,
		color:'#5F6767',
		fontWeight: '500',
  	},
  	nameBody: {
		padding:0,
		color: COLORS.blue,
		fontWeight: '700',
		maxWidth: '45vw'
  	},
  	priceBody:{
		padding:0,	
		color: COLORS.green,
		fontWeight: '700',
  	},
  	quantityBody:{
		padding:0,
		color: COLORS.blues,
		fontWeight: '600',
	},
  	root: {
		color: '#2F2F5B',
		"&$checked": {
		  color: '#2F2F5B'
		}
  	},
	storneBtn: {
		position: 'fixed',
	  	display:'flex',
	  	width: '90%',
	  	justifyContent: 'center',
		background: COLORS.blue,
		color:'#fff',
		fontSize: '1rem',
		fontWeight: '500',
		zIndex: '1',
		"&:hover": {
			backgroundColor: COLORS.blue
	  	} 
	},
  }));

const PartialStorne = ({ cid, token, transactionList, storneItem, prevPage }) => {
	const matches = useMediaQuery('(min-width:600px)')
	const [ articles, setArticles ] = useState(storneItem.articles!==undefined?(storneItem.articles!=="[]"?JSON.parse(storneItem.articles):null):null)
  	const [ isAmount, setIsAmount ] = useState(false)
	const [ total, setTotal ] = useState(parseFloat('0.00'))
	const [ storneItems, setStorneItems ] = useState([])
  	const [ isChecked, setIsChecked ] = useState(false)
  	const [ checkedDict, setCheckedDict ] = useState({})
	const [ priceDict, setPriceDict ] = useState({})
	const [ quantityDict, setQuantityDict ] = useState({})
	const [ itemsDict, setItemsDict ] = useState({})
	const [ popup, setPopup ] = useState(false)
	const [ isReject, setIsReject ] = useState(false)
	const [ keypad, setKeypad ] = useState(false)
	const [ isDisabled, setIsDisabled ] = useState(true)
	const [ isLoading, setIsLoading ] = useState(false)
	const [ isConfirm, setIsConfirm ] = useState(false)
	const [ popupIsModalLogout, setPopupIsModalLogout ] = useState(false)
	const [ width, setWidth ] = useState(window.innerWidth)
	const [ height, setHeight ] = useState(window.innerHeight)
	const navigate = useNavigate()
	const params = useParams()
  	const classes = useStyles()
	const currDate = new Date()
	const { setPageNumber, signOut, setTransactionList, resetPN } = useContext(AuthContext)

	// setup ref for your usage
	const myRef = useRef();
	const handlers = useSwipeable({ onSwipedLeft: () => handleLeftSwipe(), onSwipedRight: () => handleRightSwipe() })

	const handleLeftSwipe = () => {
			setPageNumber(4)
			setTimeout(() => {
				navigate(`/kekspos/${params.tid}/detalji/${storneItem.keks_id}`)
			},0)
	}

	const handleRightSwipe = () => {
		if(!isDisabled){
				setPopup(true)
		}
	}

	const refPassthrough = (el) => {
			// call useSwipeable ref prop with el
			handlers.ref(el)
			// set myRef el so you can access it yourself
			myRef.current = el
	}

	useEffect(() => {
		window.addEventListener('popstate', onBackButtonEvent)
	 
		return () => {
				window.removeEventListener('popstate', onBackButtonEvent);
		}
	}, [])

	const onBackButtonEvent = (e) => {
			e.preventDefault()
	 		setPageNumber(4)
			setTimeout(() => {
				navigate(`/kekspos/${params.tid}/detalji/${storneItem.keks_id}`)
			},0)	 
	}

	useEffect(() => 
        {   
            const handleReload = async (e) => 
            {
                e.preventDefault()
                signOut(cid)
                setTimeout(() => window.location.assign(`/kekspos`, 0));
                window.removeEventListener('beforeunload', handleReload) 
                return false
            }

            window.addEventListener("beforeunload", handleReload)
         
            return () => 
            {    
                window.removeEventListener('beforeunload', handleReload) 
            }
  
  	}, [])

	useEffect(()=>{
		if(total!==''&&parseFloat(total)!==0){
				setIsDisabled(false)
		}else{
				setIsDisabled(true)
		}
	},[total])

	useEffect(()=>{
		function hideKeypad(){
		   setWidth(window.innerWidth);
		   setHeight(window.innerHeight);	 	 
	   }
	    window.history.pushState(null, null, document.URL);
		window.addEventListener('resize', hideKeypad, false)
		return () => window.removeEventListener('resize', hideKeypad, false);
	},[])

	const handleArticleStorne = () => {
			setTotal(parseFloat('0.00').toFixed(2))
			setIsAmount(false)
			var arr = {}
			var priceArr= {}
			for(let num in articles){
				arr[articles[num].item.id]=false
				priceArr[articles[num].item.id]=articles[num].item.price
			}
			setCheckedDict(arr)
			setPriceDict(priceArr)
			setIsChecked(false)
	}

	const handleAmountStorne = () => 
	{
			setTotal(parseFloat('0.00').toFixed(2))
			setCheckedDict({})
			setPriceDict({})
			setItemsDict({})
			setIsChecked(false)
			setStorneItems([])
			setIsAmount(true)
	}

	const handleKeyDown = (event) => {
		if(parseInt(total)<100000){
			if(event.key>=0 && event.key<=9){
				setTotal((total*10+parseInt(event.key)*0.01).toFixed(2))
			}else if(event.key==='Backspace'){
				setTotal((Math.floor(total*10)/100).toFixed(2))
			}
		}else if(event.key==='Backspace'){
				setTotal((Math.floor(total*10)/100).toFixed(2))
		}
		if(event.key==='Enter'&&!isDisabled){
					setPopup(true)
		}
    }

	const loadCheckBox = () => {
		var arr = {}
		var priceArr = {}
		var itemsArr = {}
		var quantityArr = {}
		for(let num in articles){
			  arr[articles[num].item.id] = false
			  priceArr[articles[num].item.id] = articles[num].item.price
			  quantityArr[articles[num].item.id] = articles[num].quantity
			  itemsArr[articles[num].item.id] = JSON.stringify(articles[num])
		}
		setCheckedDict(arr)
		setPriceDict(priceArr)
		setQuantityDict(quantityArr)
		setItemsDict(itemsArr)
  	}

	useEffect(() => {
		loadCheckBox()
  	},[])

	const togglePartialStorneButton = () => {
		let sum=0
		let arr = []
		for(let ele in checkedDict){
			  if(checkedDict[ele]){
					sum+=priceDict[ele]*quantityDict[ele]
					arr.push(itemsDict[ele])
					if(!isChecked){
						setIsChecked(true)
					}
			  }
		}
		if(sum===0 && isChecked){
			  	setIsChecked(false)
			  	setTotal(0)
				setStorneItems([])
		}else{
				setTotal(parseFloat(sum.toFixed(2)))
				setStorneItems(arr)
		}
  	}

	const handleCheckboxChange = (id) => {
			var checkedEle=checkedDict
			checkedEle[id]=!checkedEle[id]
			setCheckedDict(checkedEle)
			togglePartialStorneButton()
    }

	const partialStorne = async () => {
		var partialStorneItems = "[" + storneItems.toString() + "]"
		return await axios.post(getHostNameTPS() + '/v2/refund',
						{ tid:params.tid, token:token, keks_id:storneItem.keksId, bill_id:"X", amount:total, articles:partialStorneItems, epochtime: Math.floor(new Date()/1000) }).then(response => {
								return response.data
		}).catch(error => {
								console.log("Error happend while requesting the data...")
		})

	}

	const handlePartialAmountStorne = () => {
	
		setPopup(false)
		setIsLoading(true)
		 
		//generateHash(Date.now().toString() + params.tid + total.toFixed(2) + bill_id).then( hashData => {
			partialStorne().then( apiData => {
					setIsLoading(false)
					if(apiData.resultCode===0){
						setIsConfirm(true)
						var arr = []
						const refundBillId = apiData.result.bill_id;
						console.log(refundBillId)
						for (var num in transactionList) {
							const eachBillId = transactionList[num].billId;
							console.log(eachBillId);
								if(eachBillId!==refundBillId){
										arr=[...arr, transactionList[num]]
								}else{
										var tempItem = storneItem
										tempItem.amountVoided = parseFloat(parseFloat(tempItem.amountVoided + parseFloat(total)).toFixed(2))
										if(storneItems.length>0){
												tempItem.articles = apiData.result.articles
												tempItem.refund_articles = apiData.result.refund_articles
										}
										arr=[...arr, tempItem]
								}
						}
						setTransactionList(arr)
					}else if(apiData.resultCode===333	){
						setTimeout(() => setIsLoading(false), 1000)
                        setPopupIsModalLogout(true)
					}else{
						setPopup(true)
						setIsReject(true)
					}
					
			})
		//})
	}

	const handleClose = () => {
		setPopup(false)
		if(isReject){
			handleArticleStorne()
			setIsReject(false)
		} 
	}

	const generateHash = async (input) => {
		return await md5(input)
	}

	const handleLogout = () => {
		setPopupIsModalLogout(false)
		setIsLoading(true)
		setTimeout(() => setIsLoading(false), 1000)
		resetPN()
		setTimeout(() => window.location.assign(`/kekspos`, 0))
  }

	if(!isConfirm&&!isLoading){

  return (
    <div className="partial-storne">
		<ModalStornAlert tid={params.tid} 
						token={token} 
						popup={popup}
						isReject={isReject} 
						item={storneItem} 
						pageNumber={10} 
						total={total} 
						onClose={()=>handleClose()}
						onConfirmation={()=>handlePartialAmountStorne()}
		/>
		<ModalLogoutAlert popup={popupIsModalLogout} onClose={()=>handleLogout()} />
		<div className="partial-storne-main" {...handlers} ref={refPassthrough}>
			<div className="partial-storne-header">
				<Header pageNumber={10}/>
				{articles!==null?(articles.length>0?
				<ButtonGroup className={classes.btnGroup}>
							<Button size="medium"
									className={!isAmount?classes.btnOn:classes.btnOff}
									onClick = {() => handleArticleStorne()}
							>Storno po artiklima</Button>
							<Button size="medium"
									className={isAmount?classes.btnOn:classes.btnOff}
									onClick = {() => handleAmountStorne()}
							>Storno po iznosu</Button>
				</ButtonGroup>:null):null}
			</div>
			<div className="partial-storne-body">
			{(!isAmount&&articles!==null)?
			<div>
				<div className="partial-storne-txt">Označi artikle tj. iznos vezani uz artikle koje želiš stornirati.</div>
				<div className="partial-storne-table">
					<Table stickyHeader className={classes.table} aria-label="sticky table" size="small">
                        <TableHead style={{zIndex:popup?'-1':'1'}}>
                            <TableRow>
                                <TableCell style={{padding:0, margin:0, width:!isMobile?'10%':'3%'}} 
											component="td" 
											scope="row" 
											align="right"/>
                                <TableCell  className={classes.nameHead}
											style={{width:!isMobile?'20%':'30%'}}  
											component="td" 
											scope="row"
								>Proizvod</TableCell>
                                <TableCell className={classes.priceHead}
											style={{width:!isMobile?'40%':'30%', paddingRight:!isMobile?'5%':'0%'}}
											component="td" 
											scope="row" 
											align="center"
								>Cijena</TableCell>
                                <TableCell className={classes.quantityHead}
											style={{width:!isMobile?'15%':'30%'}}   
											component="td" 
											scope="row" 
											align="right"
								>Količina</TableCell>
								{!isMobile&&<TableCell style={{width:'10%'}} component="td" scope="row"/>}
                            </TableRow>
                        </TableHead>
                        <TableBody>
                            {articles.map((ele, id) => 
                                <TableRow key={ele.item.id} className={classes.tableRow}>
                                    <TableCell className={classes.checkbox} 
												component="td" 
												scope="row" 
												align="right"
									><Checkbox key={ele.item.id} 
                                                value={checkedDict[ele.item.id]}
                                                className={classes.checkbox}
                                                icon={<CircleUnchecked />}
												style={{padding:0,margin:0}}
                                                checkedIcon={<CircleCheckedFilled className={classes.root}/>}
												//checked={checkedDict[JSON.parse(ele).id]}
												onChange={() => handleCheckboxChange(ele.item.id)}
                                    /></TableCell>
                                    <TableCell className={classes.nameBody} 
                                                component="td" 
                                                scope="row" 
                                                align="left"
                                    ><div style={{wordWrap:'break-word'}}>{ele.item.name}</div></TableCell>
                                    <TableCell className={classes.priceBody}
												style={{paddingRight:!isMobile?'5%':'0%'}}
												component="td" 
												scope="row" 
												align="center"
									>{ele.item.price} EUR</TableCell>
                                    <TableCell className={classes.quantityBody} 
												component="td" 
												scope="row" 
												align="right"
									>{ele.quantity} kom</TableCell>
									{!isMobile&&<TableCell component="td" scope="row"/>}
                                </TableRow>
                                          )}
                        </TableBody>
                    </Table>
					<div className="partial-storne-sum" style={{marginRight:!isMobile?'16%':'0%'}}>
						<span className="partial-storne-sum-txt">Iznos STORNA: </span>
						<span className="partial-storne-sum-subtxt">{total} EUR</span>
					</div>  
				</div>
			</div>:
			<div className="amount-storne" style={{top:!matches?'15vh':'20vh'}}>
				<div className="amount-storne-title">Upiši iznos koji želiš stornirati.</div>
				<TextField style={{ width:!isMobile?'25rem':'60%', textAlign: 'center'}}
									inputProps={{style: { fontSize: '1.3rem',
														textAlign: 'right', 
														paddingRight:'0.5rem' }}}
									label="Iznos"
									variant="outlined"
									type="number"
									InputProps = {{
										className: classes.input,
										endAdornment: (
												<InputAdornment position="start">
													<span style={{color:'#5F6767',
																fontSize:'1.3rem',
																}}>Eur</span>
												</InputAdornment>
						 				)
									}}
									onFocus={()=>setKeypad(true)}
									onBlur={()=>setKeypad(false)}
									value={total}
									onKeyDown={(event)=>{handleKeyDown(event)}}
					/>
			</div>
			}
			{!isAmount&&articles!==null?((!keypad||height>500)&&
						<div className="storne-btn">
							<Button size="large"
                        			variant="contained"
									disabled={!isChecked}
                        			className={classes.storneBtn}
									style={{top:!matches?'85vh':'90vh', width:!isMobile?'25rem':'90%'}}
                        			onClick={() => setPopup(true)}
                			>POTVRDI STORNO</Button>
						</div>):
						((!keypad||height>500)&&
						<div className="storne-btn">
							<Button size="large"
									variant="contained"
									disabled={isDisabled}
                        			className={classes.storneBtn}
									style={{top:!matches?'80vh':'90vh', width:!isMobile?'25rem':'90%'}}
                        			onClick={() => setPopup(true)}
                			>POTVRDI STORNO</Button>
						</div>)		
			}
		</div>
		</div>
    </div>
  )
	}else if(isConfirm&&!isLoading){
	  	return(
		  	<Confirmation cid={cid} 
			  			processed={true} 
						pageNumber={10} 
						prevPage={prevPage} 
						onBackToPartialStorne={() => setIsConfirm(false)}/>
	  	)
  	}else if(!isConfirm&&isLoading){
		return(
			<Loading />
		)
	  }
}

export default PartialStorne